<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Vestiging toevoegen</h3>

                <router-link to="/admin/locations" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <transition-group name="fade" tag="section">
                <form v-on:submit.prevent="handleSubmit" class="form form---tint" novalidate key="form">
                    <div class="g-gap:2-xs g-gap:2-sm>sm || o-card">

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Vestiging</h4>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Vestigingsnaam.$error, 'has-success': submitted && !$v.form.Vestigingsnaam.$error }">
                                <label class="u-sr-only" for="register-Vestigingsnaam">Vestigingsnaam</label>
                                <input type="text" v-model="form.Vestigingsnaam" id="register-Vestigingsnaam" name="Vestigingsnaam" class="form-control" placeholder="Vul hier de vestigingsnaam in" />
                                <div v-if="submitted && $v.form.Vestigingsnaam.$error" class="form-validation">
                                    <span v-if="!$v.form.Vestigingsnaam.required">Vestigingsnaam is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.ContactpersoonVoornaam.$error, 'has-success': submitted && !$v.form.ContactpersoonVoornaam.$error }">
                                <label class="u-sr-only" for="register-ContactpersoonVoornaam">Contactpersoon voornaam</label>
                                <input type="text" v-model="form.ContactpersoonVoornaam" id="register-ContactpersoonVoornaam" name="ContactpersoonVoornaam" class="form-control" placeholder="Vul hier de contactpersoon voornaam in" />
                                <div v-if="submitted && $v.form.ContactpersoonVoornaam.$error" class="form-validation"></div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.ContactpersoonAchternaam.$error, 'has-success': submitted && !$v.form.ContactpersoonAchternaam.$error }">
                                <label class="u-sr-only" for="register-ContactpersoonAchternaam">Contactpersoon achternaam</label>
                                <input type="text" v-model="form.ContactpersoonAchternaam" id="register-ContactpersoonAchternaam" name="ContactpersoonAchternaam" class="form-control" placeholder="Vul hier de contactpersoon achternaam in" />
                                <div v-if="submitted && $v.form.ContactpersoonAchternaam.$error" class="form-validation">
                                    <span v-if="!$v.form.ContactpersoonAchternaam.required">Contactpersoon achternaam is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Vestigingsadres.$error, 'has-success': submitted && !$v.form.Vestigingsadres.$error }">
                                <label class="u-sr-only" for="register-Vestigingsadres">Vestigingsadres</label>
                                <input type="text" v-model="form.Vestigingsadres" id="register-Vestigingsadres" name="Vestigingsadres" class="form-control" placeholder="Vul hier het vestigingsadres in" />
                                <div v-if="submitted && $v.form.Vestigingsadres.$error" class="form-validation">
                                    <span v-if="!$v.form.Vestigingsadres.required">Vestigingsadres is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Vestigingspostcode.$error, 'has-success': submitted && !$v.form.Vestigingspostcode.$error }">
                                <label class="u-sr-only" for="register-Vestigingspostcode">Vestigingspostcode</label>
                                <input type="text" v-model="form.Vestigingspostcode" id="register-Vestigingspostcode" name="Vestigingspostcode" class="form-control" placeholder="Vul hier de vestigingspostcode in" />
                                <div v-if="submitted && $v.form.Vestigingspostcode.$error" class="form-validation">
                                    <span v-if="!$v.form.Vestigingspostcode.required">Vestigingspostcode is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Vestigingsplaats.$error, 'has-success': submitted && !$v.form.Vestigingsplaats.$error }">
                                <label class="u-sr-only" for="register-Vestigingsplaats">Vestigingsplaats</label>
                                <input type="text" v-model="form.Vestigingsplaats" id="register-Vestigingsplaats" name="Vestigingsplaats" class="form-control" placeholder="Vul hier de vestigingsplaats in" />
                                <div v-if="submitted && $v.form.Vestigingsplaats.$error" class="form-validation">
                                    <span v-if="!$v.form.Vestigingsplaats.required">Vestigingsplaats is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Vestigingsland.$error, 'has-success': submitted && !$v.form.Vestigingsland.$error }">
                                <label class="u-sr-only" for="register-Vestigingsland">Vestigingsland</label>
                                <select v-model="form.Vestigingsland" id="register-Vestigingsland" name="Vestigingsland" class="form-control">
                                    <option value="x" disabled selected>Vul hier het vestigingsland in</option>
                                    <option v-for="country in countries" :value="country" :key="country">{{ country }}</option>
                                </select>
                                <div v-if="submitted && $v.form.Vestigingsland.$error" class="form-validation">
                                    <span v-if="!$v.form.Vestigingsland.required">Vestigingsland is verplicht</span>
                                </div>
                            </div>

                            <div class="custom-checkbox">
                                <label for="register-AdressenGelijk" class="custom-control-label">
                                    <input type="checkbox" v-model="AdressenGelijkChecked" :value="AdressenGelijkChecked ? 'Ja' : 'Nee'" name="AdressenGelijk" id="register-AdressenGelijk" class="custom-control-input" />
                                    <span class="custom-control-name">Factuurgegevens hetzelfde als vestigingsgegevens</span>
                                </label>
                            </div>
                        </div>

                        <div class="form-fieldset" v-if="!AdressenGelijkChecked">
                            <h4 class="u-mb-0">Factuurgegevens</h4>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuurnaam.$error, 'has-success': submitted && !$v.form.Factuurnaam.$error }">
                                <label class="u-sr-only" for="register-Factuurnaam">Factuurnaam</label>
                                <input type="text" v-model="form.Factuurnaam" id="register-Factuurnaam" name="Factuurnaam" class="form-control" placeholder="Vul hier de factuurnaam in"  />
                                <div v-if="submitted && $v.form.Factuurnaam.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuurnaam.required">Factuurnaam is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuuradres.$error, 'has-success': submitted && !$v.form.Factuuradres.$error }">
                                <label class="u-sr-only" for="register-Factuuradres">Factuuradres</label>
                                <input type="text" v-model="form.Factuuradres" id="register-Factuuradres" name="Factuuradres" class="form-control" placeholder="Vul hier het factuuradres in"  />
                                <div v-if="submitted && $v.form.Factuuradres.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuuradres.required">Factuuradres is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuurpostcode.$error, 'has-success': submitted && !$v.form.Factuurpostcode.$error }">
                                <label class="u-sr-only" for="register-Factuurpostcode">Factuurpostcode</label>
                                <input type="text" v-model="form.Factuurpostcode" id="register-Factuurpostcode" name="Factuurpostcode" class="form-control" placeholder="Vul hier de factuurpostcode in"  />
                                <div v-if="submitted && $v.form.Factuurpostcode.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuurpostcode.required">Factuurpostcode is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuurplaats.$error, 'has-success': submitted && !$v.form.Factuurplaats.$error }">
                                <label class="u-sr-only" for="register-Factuurplaats">Factuurplaats</label>
                                <input type="text" v-model="form.Factuurplaats" id="register-Factuurplaats" name="Factuurplaats" class="form-control" placeholder="Vul hier de factuurplaats in"  />
                                <div v-if="submitted && $v.form.Factuurplaats.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuurplaats.required">Factuurplaats is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuurland.$error, 'has-success': submitted && !$v.form.Factuurland.$error }">
                                <label class="u-sr-only" for="register-Factuurland">Factuurland</label>
                                <select v-model="form.Factuurland" id="register-Factuurland" name="Factuurland" class="form-control" >
                                    <option value="x" disabled selected>Vul hier het factuurland in</option>
                                    <option v-for="country in countries" :value="country" :key="country">{{ country }}</option>
                                </select>
                                <div v-if="submitted && $v.form.Factuurland.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuurland.required">Factuurland is verplicht</span>
                                </div>
                            </div>

                        </div>

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Factuur</h4>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.FactuurTAV.$error, 'has-success': submitted && !$v.form.FactuurTAV.$error }">
                                <label class="u-sr-only" for="register-FactuurTAV">Factuur TAV</label>
                                <input type="text" v-model="form.FactuurTAV" id="register-FactuurTAV" name="FactuurTAV" class="form-control" placeholder="Vul hier de factuur TAV in"  />
                                <div v-if="submitted && $v.form.FactuurTAV.$error" class="form-validation">
                                    <span v-if="!$v.form.FactuurTAV.required">FactuurTAV is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuurkenmerk.$error, 'has-success': submitted && !$v.form.Factuurkenmerk.$error }">
                                <label class="u-sr-only" for="register-Factuurkenmerk">Factuur kenmerk</label>
                                <input type="text" v-model="form.Factuurkenmerk" id="register-Factuurkenmerk" name="Factuurkenmerk" class="form-control" placeholder="Vul hier het factuur kenmerk in"  />
                                <div v-if="submitted && $v.form.Factuurkenmerk.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuurkenmerk.required">Factuur kenmerk is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.Factuuremail.$error, 'has-success': submitted && !$v.form.Factuuremail.$error }">
                                <label class="u-sr-only" for="login-Factuuremail">Factuur e-mailadres</label>
                                <input type="email" v-model="form.Factuuremail" id="login-Factuuremail" name="Factuuremail" class="form-control" placeholder="Vul hier het factuur e-mailadres in" />
                                <div v-if="submitted && $v.form.Factuuremail.$error" class="form-validation">
                                    <span v-if="!$v.form.Factuuremail.required">Factuur e-mailadres is verplicht</span>
                                    <span v-if="!$v.form.Factuuremail.email">Factuur e-mailadres is ongeldig</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Overig</h4>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.KNMP.$error, 'has-success': submitted && !$v.form.KNMP.$error }">
                                <label class="u-sr-only" for="register-KNMP">KNMP nummer</label>
                                <input type="text" v-model="form.KNMP" id="register-KNMP" name="KNMP" class="form-control" placeholder="Vul hier het KNMP nummer in" />
                                <div v-if="submitted && $v.form.KNMP.$error" class="form-validation">
                                    <span v-if="!$v.form.KNMP.integer">KNMP nummer moet een nummer zijn</span>
                                    <span v-if="!$v.form.KNMP.maxLength">Maximaal 9 karakters</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.AGBcode.$error, 'has-success': submitted && !$v.form.AGBcode.$error }">
                                <label class="u-sr-only" for="register-AGBcode">AGB code</label>
                                <input type="text" v-model="form.AGBcode" id="register-AGBcode" name="AGBcode" class="form-control" placeholder="Vul hier de AGB code in" />
                                <div v-if="submitted && $v.form.AGBcode.$error" class="form-validation">
                                    <span v-if="!$v.form.AGBcode.integer">AGB code moet een nummer zijn</span>
                                    <span v-if="!$v.form.AGBcode.maxLength">Maximaal 9 karakters</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.AIS.$error, 'has-success': submitted && !$v.form.AIS.$error }">
                                <label class="u-sr-only" for="register-AIS">AIS</label>
                                <select v-model="form.AIS" id="register-AIS" name="AIS" class="form-control">
                                    <option value="x" disabled selected>Vul hier het AIS in</option>
                                    <option v-for="ais in aissen" :value="ais" :key="ais">{{ ais }}</option>
                                </select>
                                <div v-if="submitted && $v.form.AIS.$error" class="form-validation">
                                    <span v-if="!$v.form.AIS.required">AIS is verplicht</span>
                                </div>
                            </div>

                            <div v-show="aisPharmaCom" class="form-group" :class="{ 'has-error': submitted && $v.form.PP_OC_code.$error, 'has-success': submitted && !$v.form.PP_OC_code.$error }">
                                <label class="u-sr-only" for="register-PP_OC_code">Pharmacom OC-code</label>
                                <input type="text" v-model="form.PP_OC_code" id="register-PP_OC_code" name="PP_OC_code" class="form-control" placeholder="Vul hier de Pharmacom OC-code in" />
                                <div v-if="submitted && $v.form.PP_OC_code.$error" class="form-validation">
                                    <span v-if="!$v.form.PP_OC_code.required">Pharmacom OC-code is verplicht</span>
                                </div>
                            </div>

                            <div v-show="aisPharmaCom" class="form-group" :class="{ 'has-error': submitted && $v.form.PP_Apotheekletters.$error, 'has-success': submitted && !$v.form.PP_Apotheekletters.$error }">
                                <label class="u-sr-only" for="register-PP_Apotheekletters">Pharmacom apotheekletters</label>
                                <input type="text" v-model="form.PP_Apotheekletters" id="register-PP_Apotheekletters" name="PP_Apotheekletters" class="form-control" placeholder="Vul hier de Pharmacom apotheekletters in" />
                                <div v-if="submitted && $v.form.PP_Apotheekletters.$error" class="form-validation">
                                    <span v-if="!$v.form.PP_Apotheekletters.required">Pharmacom apotheekletters zijn verplicht</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Automatische incasso</h4>

                            <div class="form-group">
                                <div class="custom-checkbox">
                                    <label for="register-MachtigingAkkoord" class="custom-control-label">
                                        <input type="checkbox" v-model="MachtigingAkkoord" :value="MachtigingAkkoord ? 'Ja' : 'Nee'" name="MachtigingAkkoord" id="register-MachtigingAkkoord" class="custom-control-input" />
                                        <span class="custom-control-name">Ik ga akkoord met automatische incasso</span>
                                    </label>
                                </div>
                            </div>

                            <div class="form-fieldset" v-if="MachtigingAkkoord">
                                <div class="form-group" :class="{ 'has-error': submitted && $v.form.IBAN.$error, 'has-success': submitted && !$v.form.IBAN.$error }">
                                    <label class="u-sr-only" for="register-IBAN">IBAN</label>
                                    <input type="text" v-model="form.IBAN" id="register-IBAN" name="IBAN" class="form-control" placeholder="Vul hier het IBAN in" />
                                    <div v-if="submitted && $v.form.IBAN.$error" class="form-validation">
                                        <span v-if="!$v.form.IBAN.required">IBAN is verplicht</span>
                                        <span v-if="!$v.form.IBAN.isValidIBANNumber">IBAN is ongeldig</span>
                                    </div>
                                </div>

                                <p class="u-mb-0">Ondergetekende verklaart hierbij in rechte op te mogen treden voor deze vestiging:</p>

                                <div class="form-group" :class="{ 'has-error': submitted && $v.form.MachtigingNaam.$error, 'has-success': submitted && !$v.form.MachtigingNaam.$error }">
                                    <label class="u-sr-only" for="register-MachtigingNaam">Naam</label>
                                    <input type="text" v-model="form.MachtigingNaam" id="register-MachtigingNaam" name="MachtigingNaam" class="form-control" placeholder="Vul hier je voor- en achternaam in" />
                                    <div v-if="submitted && $v.form.MachtigingNaam.$error" class="form-validation">
                                        <span v-if="!$v.form.MachtigingNaam.required">Naam is verplicht</span>
                                    </div>
                                </div>

                                <div class="form-group" :class="{ 'has-error': submitted && $v.form.MachtigingDatum.$error, 'has-success': submitted && !$v.form.MachtigingDatum.$error }">
                                    <label class="u-sr-only" for="register-MachtigingDatum">Datum</label>
                                    <input type="text" v-model="form.MachtigingDatum" id="register-MachtigingDatum" name="MachtigingDatum" class="form-control" placeholder="Vul hier de huidige datum in" />
                                    <div v-if="submitted && $v.form.MachtigingDatum.$error" class="form-validation">
                                        <span v-if="!$v.form.MachtigingDatum.required">Datum is verplicht</span>
                                    </div>
                                </div>

                                <div class="form-group" :class="{ 'has-error': submitted && $v.form.MachtigingPlaats.$error, 'has-success': submitted && !$v.form.MachtigingPlaats.$error }">
                                    <label class="u-sr-only" for="register-MachtigingPlaats">Plaats akkoord</label>
                                    <input type="text" v-model="form.MachtigingPlaats" id="register-MachtigingPlaats" name="MachtigingPlaats" class="form-control" placeholder="Vul hier de plaats van akkoord in" />
                                    <div v-if="submitted && $v.form.MachtigingPlaats.$error" class="form-validation">
                                        <span v-if="!$v.form.MachtigingPlaats.required">Plaats is verplicht</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="form-validation || u-text-danger">
                                <span>Indien we geen gebruik kunnen maken van automatische incasso, brengen we administratiekosten per factuur in rekening. </span>
                            </div>
                        </div>

                        <div class="custom-checkbox" :class="{ 'has-error': submitted && $v.form.privacy.$error }">
                            <label for="register-privacy" class="custom-control-label">
                                <input type="checkbox" v-model="form.privacy" name="privacy" id="register-privacy" class="custom-control-input" />
                                <span class="custom-control-name">Ik ga akkoord met de <a class="u-font-weight-bold" href="https://www.addsoft.nl/voorwaarden" target="_blank">algemene voorwaarden</a></span>
                            </label>
                            <div v-if="submitted && $v.form.privacy.$error" class="form-validation">
                                <span v-if="!$v.form.privacy.checked">Je dient akkoord te gaan met de algemene voorwaarden</span>
                            </div>
                        </div>

                    </div>

                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.adding">
                        <span v-show="status.adding"><spinner/></span>
                        <span v-show="!status.adding">Vestiging opslaan</span>
                        <svg v-show="!status.adding" xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                <path d="M1 7.438h12.875"/>
                                <path d="M7.437 1v12.875"/>
                            </g>
                        </svg>
                    </button>
                </form>
            </transition-group>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import {
        email,
        integer,
        required,
        minLength,
        maxLength,
    } from 'vuelidate/lib/validators';
    import isValidIBANNumber from '../../helpers/ibanValidator';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Spinner from '../../components/Spinner.vue';
    import normalizeFormData from '../../helpers/normalizeFormData';

    export default {
        components: { Spinner, AppIntro },
        data () {
            return {
                submitted: false,
                loading: true,
                aisPharmaCom: false,
                AdressenGelijkChecked: true,
                MachtigingAkkoord: true,
                form: {
                    VestigingID: '0',
                    VestigingUUID: '0',
                    Vestigingsnaam: '',
                    Contactpersoon: '',
                    Vestigingsadres: '',
                    Vestigingspostcode: '',
                    Vestigingsplaats: '',
                    Vestigingsland: 'Nederland',

                    AdressenGelijk: '',

                    Factuurnaam: '',
                    FactuurTAV: '',
                    Factuuradres: '',
                    Factuurpostcode: '',
                    Factuurplaats: '',
                    Factuurland: 'Nederland',
                    Factuurkenmerk: '',
                    Factuuremail: '',

                    IBAN: '',
                    MachtigingAkkoord: '',
                    MachtigingNaam: '',
                    MachtigingDatum: `${new Date(Date.now()).toLocaleDateString('nl-NL')} ${new Date(Date.now()).toLocaleTimeString('nl-NL')}`,
                    MachtigingPlaats: '',

                    privacy: '',

                    KNMP: '',
                    AGBcode: '',
                    AIS: 'Overig',

                    PP_OC_code: '',
                    PP_Apotheekletters: '',
                },
            };
        },
        computed: {
            ...mapState('location', ['status']),
            ...mapState('kernel', ['countries', 'aissen']),
        },
        watch: {
            'form.AIS': {
                handler (value) {
                    this.aisPharmaCom = (value === 'Pharmacom');
                },
                deep: true,
            },
        },
        validations () {
            const baseValidators = {
                Vestigingsnaam: { required },
                Vestigingsadres: { required },
                ContactpersoonVoornaam: { minLength: minLength(1) },
                ContactpersoonAchternaam: { required },
                Vestigingspostcode: { required },
                Vestigingsplaats: { required },
                Vestigingsland: { required },

                FactuurTAV: { minLength: minLength(2) },
                Factuurkenmerk: { minLength: minLength(2) },
                Factuuremail: { required, email },

                KNMP: {
                    // required,
                    integer,
                    minLength: minLength(1),
                    maxLength: maxLength(9),
                },
                AGBcode: {
                    // required,
                    integer,
                    minLength: minLength(1),
                    maxLength: maxLength(9),
                },
                AIS: { required },
                PP_OC_code: { minLength: minLength(1) },
                PP_Apotheekletters: { minLength: minLength(1) },

                privacy: {
                    checked: (value) => value === true,
                },
            };

            let ibanValidators = {
                /*MachtigingAkkoord: {
                    checked () {
                        return this.MachtigingAkkoord;
                    },
                },*/
            };

            if (this.MachtigingAkkoord)
            {
                ibanValidators = {
                    ...ibanValidators,
                    IBAN: { required, isValidIBANNumber },
                    MachtigingNaam: { required },
                    MachtigingDatum: { required },
                    MachtigingPlaats: { required },
                };
            }

            if (this.AdressenGelijkChecked)
            {
                return {
                    form: {
                        ...baseValidators,
                        ...ibanValidators,

                        Factuurnaam: { minLength: minLength(2) },
                        Factuuradres: { minLength: minLength(2) },
                        Factuurpostcode: { minLength: minLength(2) },
                        Factuurplaats: { minLength: minLength(2) },
                        Factuurland: { minLength: minLength(2) },

                    },
                };
            }

            if (!this.AdressenGelijkChecked)
            {
                return {
                    form: {
                        ...baseValidators,
                        ...ibanValidators,

                        Factuurnaam: { required },
                        Factuuradres: { required },
                        Factuurpostcode: { required },
                        Factuurplaats: { required },
                        Factuurland: { required },
                    },
                };
            }

            return {};
        },
        async created () {
            // get countries
            await this.$store.dispatch('kernel/countries');

            // get aissen
            await this.$store.dispatch('kernel/aissen');

            // reset loading
            this.loading = false;
        },
        methods: {
            async handleSubmit (e) {
                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // kick off the update
                this.$store.dispatch('location/create', { data });
            },
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

</style>
